import React from 'react';
import PropTypes from 'prop-types';
import { IndexLink } from 'react-router';
import _ from 'lodash';
import classNames from 'classnames';
import { getNetworkLogoUrl } from 'helpers/ContentHelper';
import { helperGetHomeUrl } from 'helpers/RouteHelper';
import { SITE_PLATFORM_WEB } from 'helpers/BreakpointHelper';
import NetworkImage from 'components/NetworkImage';
import Style from './NetworkLink.module.scss';

const NetworkLink = props => {
  const { breakpoint, clickEvent, disableLink, isHeader } = props;

  const to = helperGetHomeUrl();
  const onClick = clickEvent;

  const classes = [];
  const indexIsSlash = to === '/';

  classes.push(Style.logo);
  const className = classNames(classes);
  const linkProps = {
    className,
    onClick,
  };
  const network = _.get(window.ExternalConfig, 'brand.headerLogo', null);
  const networkImageProps = { breakpoint, lazyLoad: false };

  if (isHeader && network) {
    networkImageProps.url = getNetworkLogoUrl(network);
  }
  if (network) networkImageProps.network = network;
  if (!disableLink) {
    linkProps.href = to;
    linkProps.to = to;
  }
  const networkImage = <NetworkImage {...networkImageProps} />;

  if (!indexIsSlash && !isHeader) return <a {...linkProps}>{networkImage}</a>;

  return <IndexLink {...linkProps}>{networkImage}</IndexLink>;
};

NetworkLink.defaultProps = {
  breakpoint: SITE_PLATFORM_WEB,
  clickEvent: () => {},
  disableLink: false,
  hideNetworkLogo: false,
  isHeader: null,
  preauthorizedResources: null,
};

NetworkLink.propTypes = {
  breakpoint: PropTypes.string,
  clickEvent: PropTypes.func,
  disableLink: PropTypes.bool,
  hideNetworkLogo: PropTypes.bool,
  isHeader: PropTypes.bool,
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
};

export default NetworkLink;
